import { AxiosInstance } from 'axios';

import { Variant, DeleteItemsInput } from '../../types';
import { PaginationRequest } from '../../types/PaginationRequest';
import { StockVariants } from '../../types/Variant';
import { variantEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { CreateVariantInput, UpdateVariantInput } from './VariantsApi.schema';

class VariantsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (variant: CreateVariantInput): Promise<Variant> => {
    return this.#requestInstance.post(variantEndpoints.variant, variant);
  };

  deleteVariant = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(variantEndpoints.getVariantById(id));
  };

  deleteManyVariants = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(variantEndpoints.variant, { data: input });
  };

  getVariantById = async (id: number): Promise<Variant> => {
    return this.#requestInstance.get(variantEndpoints.getVariantById(id));
  };

  getVariants = async (data?: PaginationRequest): Promise<StockVariants> => {
    return this.#requestInstance.get(variantEndpoints.variant, { params: data });
  };

  updateVariant = async (input: UpdateVariantInput): Promise<Variant> => {
    return this.#requestInstance.patch(variantEndpoints.getVariantById(input.id), input.variant);
  };
}

export const variantsApi = new VariantsApi(axios);
